module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "page-single"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-login mx-auto"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "card",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-body p-6"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("Login to e-MemberS")]), _vm._v(" "), (_vm.response != '') ? _c('div', {
    staticClass: "alert alert-icon alert-primary alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.response) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("User")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "tabindex": "1",
      "name": "username",
      "aria-describedby": "emailHelp",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "tabindex": "1",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loadingSubmit) ? _c('span', [_c('i', {
    staticClass: "icon ion-spinner fa-spin"
  }), _vm._v(" Login...")]) : _c('span', [_vm._v("Login")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("Copyright © 2019 Sinarmas Land")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center mb-6"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo_blk.png",
      "alt": "Membership Logo",
      "width": "100"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Password"), _c('a', {
    staticClass: "float-right small",
    attrs: {
      "href": "/recover"
    }
  }, [_vm._v("I forgot the password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afe058f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 816
// module chunks = 1